// src/components/character/FigryneGiftModal.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { config } from '../../config';

interface FigryneGiftModalProps {
  characterId: string;
  onClose: () => void;
}

const FigryneGiftModal: React.FC<FigryneGiftModalProps> = ({ characterId, onClose }) => {
  const { t } = useTranslation('create');

  const handleCreateNow = () => {
    const returnUrl = encodeURIComponent(window.location.href);
    window.location.href = `${config.figryneUrl}/creator/gift-upload?characterId=${characterId}&returnUrl=${returnUrl}`;
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-sm w-[90%] mx-4 overflow-hidden">
        {/* Header gradient */}
        <div className="bg-gradient-to-r from-purple-500 via-pink-500 to-orange-400 px-6 py-8 text-center">
          <div className="text-4xl mb-3">🎉</div>
          <h2 className="text-xl font-bold text-white">
            {t('gift.title', 'VTuber登録完了！')}
          </h2>
        </div>

        {/* Body */}
        <div className="px-6 py-6">
          <p className="text-sm text-gray-700 dark:text-gray-300 text-center leading-relaxed mb-6">
            {t('gift.description', '特典としてFIGRYNE（デジタルアクリルフィギュア）を有料マテリアル仕様で1体プレゼント！')}
          </p>

          {/* Buttons */}
          <div className="space-y-3">
            <button
              onClick={handleCreateNow}
              className="w-full py-3 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-semibold rounded-xl transition-all hover:shadow-lg"
            >
              {t('gift.createNow', '今すぐ作る')}
            </button>
            <button
              onClick={onClose}
              className="w-full py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-600 dark:text-gray-300 font-medium rounded-xl transition-colors"
            >
              {t('gift.later', 'あとで')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FigryneGiftModal;
